export const getUserName = (state) => state.auth?.token?.username;
export const getUserType = (state) => state.auth?.token?.type;
export const getToken = (state) => state.auth?.token;
export const getProfile = (state) => state.auth?.profile;
export const getBusinessProfile = (state) => state.auth?.businessProfile;
